export const MAX_NAME_LEN = 100;
export const MAX_DESCR_LEN = 100;
export const MAX_CAPTION_LEN = 1000;
export const MAX_CREDIT_LEN = 200;
